import { Observable } from 'rxjs';
import { GgFaq } from '../../model/gg-faq.model';

export abstract class FaqAdapter {
  abstract load(id: string): Observable<GgFaq>;
}
